import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

import OpacityIcon from '../../../../../../../icons/OpacityIcon';
import RangeSlider from '../../../../../../RangeSlider';
import Input from '../../../../../../Input';
import DropdownMenu from '../../../../../../DropdownMenu';

const propTypes = {
  element: PropTypes.shape({
    id: PropTypes.string,
    cardElementConfiguration: PropTypes.shape({
      opacity: PropTypes.number,
    }),
  }).isRequired,
  onElementConfigurationChange: PropTypes.func.isRequired,
};

const CardDesignerCardElementOpacityControls = ({
  element,
  onElementConfigurationChange,
}) => {
  const { cardElementConfiguration } = element;
  const { opacity: elementOpacity } = cardElementConfiguration ?? {};

  const [opacity, setOpacity] = useState(elementOpacity ?? 1);

  useEffect(() => {
    setOpacity(elementOpacity ?? 1);
  }, [elementOpacity]);

  return (
    <DropdownMenu
      placement="bottom-start"
      dropdownClassName="card-designer-card-element-common-control-dropdown card-designer-card-element-opacity-controls-dropdown"
      toggleClassName="ml-1 d-flex align-items-center"
      toggle={
        <span
          data-for="opacity-controls"
          data-place="bottom"
          data-effect="solid"
          data-tip
        >
          <OpacityIcon size={22} />
          <ReactTooltip id="opacity-controls" className="tooltip">
            Opacity Controls
          </ReactTooltip>
        </span>
      }
    >
      <div className="p-2 d-flex w-100 align-items-center ml-auto text-sm text-nowrap">
        <span className="mr-1">Opacity</span>
        <RangeSlider
          className="mx-2"
          onChange={values => {
            setOpacity(Math.round((values[0] / 1e2) * 1e2) / 1e2);
          }}
          onFinalChange={values => {
            onElementConfigurationChange({
              element,
              elementConfig: {
                opacity: Math.round((values[0] / 1e2) * 1e2) / 1e2,
              },
            });
          }}
          values={[Math.round(opacity * 1e2)]}
          min={0}
          max={100}
        />
        <Input
          id="opacity"
          type="number"
          max={100}
          min={0}
          className="mr-1"
          value={Math.round(opacity * 1e2)}
          onChange={({ target }) => {
            const percentValue = Math.round((target.value / 1e2) * 1e2) / 1e2;
            setOpacity(percentValue);
            onElementConfigurationChange({
              element,
              elementConfig: {
                opacity: percentValue,
              },
            });
          }}
        />{' '}
        <span className="input-addon-text">%</span>
      </div>
    </DropdownMenu>
  );
};

CardDesignerCardElementOpacityControls.propTypes = propTypes;

export default CardDesignerCardElementOpacityControls;
